var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoolBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 46,
    viewBox: "0 0 38 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.155518,
    y: 0.563721,
    width: 37.7871,
    height: 44.7918,
    rx: 10,
    fill: "#5387FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.854,
    y: 8.73511,
    width: 14.2298,
    height: 28.4489,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_296_21375",
    transform: "translate(-0.499628) scale(0.0833023 0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_296_21375",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYEAQAAAAa7ikwAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAAAGAAAABgAPBrQs8AAAAHdElNRQfmDAIJOiUCTEYEAAACZ0lEQVRIx+1Uv0uqURh+zpddhX7YL0WkKSoSHUWCRMJJWoKgoWhJaItoauwvaGk0VCiaW4KycGgJ+jKJtowsMon8CGoIXPQ8d/i4nO7N/G613OE+04HnOe/7PLzvOYAFKF0uyo0N8umJMhh8x7O3V/GhkFW9P4r39ZFXV2StRu7sULrdv/NOJ1kokPU6ubtLer2fa8D1dVJKcmqqsYG1NZKknJ7+qIZonqBYBAwDYmKisULXAcMQIhz+lHOVoF6nJdLpZjVszVtoGnBxAWQyjfmVFUDKL7k3E5BkIvExX6uRyeQ3EgCA3U52d3/ZpXUCK3w7gdUMvp3g/wws8Y/PQGveQsrmL7VWA+p1C5cOB9nS0pCTc3Ok30+2tZGa9v7uzAzp85nnxhoNKBSAapU8OiKjUVXc6YQYHASyWeD1FahWKbNZykhEXc9kgNlZslJRmsNDcmzsl0KQ8TgwPg5MTgKdnUC5DD4+QgQCgMMBnp1BHB+DXi9ELAZ0dAD394BhAIEAYLcDuZz5dXs8QCwGtLcDd3fA3p5QcXt6gMVFs5nTCRaLQColtIMDlcrlglhaMjVdXcDlJZhICC2bVRq3G1hehohEgOfnv96oL4PM58nbW3JzkxwZUU5sNnJ+ntR10jDImxsynaYcGlKa1lbKhQXKXI40DMpikUwmyYGBNzNYXQWiUSAcBkhA18FKBSIUAvr7gXIZyOdBjwciGDTXVtdBw4AYHQW8XuDhwdS43UpzcgLs779ZyeFhylSK8vradKzrprsfP1Ran4/c2iJLJfLlhTw9JeNxSptNafx+cnubLJUoz89/AvDKDUCadv0gAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIyLTEyLTAyVDA5OjU4OjM2KzAwOjAwvPVjIQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMi0xMi0wMlQwOTo1ODozNiswMDowMM2o250AAAAodEVYdGRhdGU6dGltZXN0YW1wADIwMjItMTItMDJUMDk6NTg6MzYrMDA6MDCavfpCAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoolBlue);
export default __webpack_public_path__ + "static/media/pool-blue.6e7345c38332ee418ef200668aad271d.svg";
export { ForwardRef as ReactComponent };